import { render, staticRenderFns } from "./ReviewOrderStackedColumn.vue?vue&type=template&id=51bcf414"
import script from "./ReviewOrderStackedColumn.vue?vue&type=script&lang=js"
export * from "./ReviewOrderStackedColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports